import { useEffect, useState } from "react";
import "./Admin.css";
import { db } from "../firebase";

import {
  collection,
  addDoc,
  getDocs,
  deleteDoc,
  doc,
  updateDoc
} from "firebase/firestore";

function Admin() {

  const categories = [
    "Baby",
    "Girls",
    "Boy",
    "Accessories",
    "Toys",
    "Gifts",
    "Nursery",
    "Back to School"
  ];

  const babySubCategories = [
    "Boy",
    "Girl",
    "Hospital Sets",
    "Bodysuits & Rompers",
    "Accessories"
  ];

  const accessories = [
    "Swaddles & Blankets",
    "Hats",
    "Socks & Tights",
    "Hair",
    "Washcloths",
    "Gloves"
  ];

  const [products, setProducts] = useState([]);

  const [product, setProduct] = useState({
    name: "",
    description: "",
    price: "",
    stock: "",
    age: "",
    category: "",
    subCategory: "",
    accessory: "",
    colors: [],
    sizes: []
  });

  const [files, setFiles] = useState([]);

  const [colorInput, setColorInput] = useState("");
  const [sizeInput, setSizeInput] = useState("");


  // =========================
  // GET PRODUCTS
  // =========================

  const getProducts = async () => {

    try {

      const snapshot = await getDocs(
        collection(db, "products")
      );

      const data = snapshot.docs.map(item => ({
        id: item.id,
        ...item.data()
      }));

      setProducts(data);

    } catch (error) {

      console.error(error);

    }

  };


  useEffect(() => {

    getProducts();

  }, []);


  // =========================
  // INPUT CHANGE
  // =========================

  const handleChange = (e) => {

    const { name, value } = e.target;

    setProduct(prev => ({
      ...prev,

      [name]: value,

      ...(name === "category" && {
        subCategory: "",
        accessory: ""
      }),

      ...(name === "subCategory" && {
        accessory: ""
      })

    }));

  };


  // =========================
  // IMAGE
  // =========================

  const convertImage = (file) => {

    return new Promise((resolve, reject) => {

      const reader = new FileReader();

      reader.readAsDataURL(file);

      reader.onload = () => resolve(reader.result);

      reader.onerror = error => reject(error);

    });

  };


  // =========================
  // ADD PRODUCT
  // =========================

  const addProduct = async (e) => {

    e.preventDefault();


    if (
      !product.name ||
      !product.price ||
      !product.category
    ) {

      alert("املئي المعلومات الأساسية");

      return;

    }


    try {

      let images = [];


      for (let file of files) {

        const img = await convertImage(file);

        images.push(img);

      }


      await addDoc(
        collection(db, "products"),
        {
          ...product,

          price: Number(product.price),

          stock: Number(
            product.stock || 0
          ),

          images
        }
      );


      alert("تمت إضافة المنتج ✅");


      setProduct({
        name: "",
        description: "",
        price: "",
        stock: "",
        age: "",
        category: "",
        subCategory: "",
        accessory: "",
        colors: [],
        sizes: []
      });


      setFiles([]);

      setColorInput("");

      setSizeInput("");


      getProducts();


    } catch (error) {

      console.error(error);

      alert("حدث خطأ");

    }

  };


  // =========================
  // DELETE
  // =========================

  const deleteProduct = async (id) => {

    await deleteDoc(
      doc(db, "products", id)
    );

    getProducts();

  };


  // =========================
  // EDIT PRICE
  // =========================

  const editPrice = async (id) => {

    const price = prompt("السعر الجديد");


    if (price) {

      await updateDoc(
        doc(db, "products", id),
        {
          price: Number(price)
        }
      );

      getProducts();

    }

  };


  return (

    <div className="admin-layout">

      <div className="admin-content">

        <h1>
          لوحة التحكم
        </h1>


        <form
          className="admin-form"
          onSubmit={addProduct}
        >


          {/* PRODUCT NAME */}

          <input
            name="name"
            placeholder="اسم المنتج"
            value={product.name}
            onChange={handleChange}
          />


          {/* DESCRIPTION */}

          <textarea
            name="description"
            placeholder="الوصف"
            value={product.description}
            onChange={handleChange}
          />


          {/* PRICE */}

          <input
            name="price"
            type="number"
            placeholder="السعر"
            value={product.price}
            onChange={handleChange}
          />


          {/* CATEGORY */}

          <select
            name="category"
            value={product.category}
            onChange={handleChange}
          >

            <option value="">
              اختار القسم
            </option>

            {categories.map(cat => (

              <option
                key={cat}
                value={cat}
              >
                {cat}
              </option>

            ))}

          </select>


          {/* BABY SUB CATEGORY */}

          {product.category === "Baby" && (

            <select
              name="subCategory"
              value={product.subCategory}
              onChange={handleChange}
            >

              <option value="">
                اختار قسم Baby
              </option>

              {babySubCategories.map(item => (

                <option
                  key={item}
                  value={item}
                >
                  {item}
                </option>

              ))}

            </select>

          )}


          {/* BABY ACCESSORIES */}

          {product.category === "Baby" &&
            product.subCategory === "Accessories" && (

              <select
                name="accessory"
                value={product.accessory}
                onChange={handleChange}
              >

                <option value="">
                  اختار النوع
                </option>

                {accessories.map(item => (

                  <option
                    key={item}
                    value={item}
                  >
                    {item}
                  </option>

                ))}

              </select>

          )}


          {/* COLORS */}

          <h3>
            Colors 🎨
          </h3>


          <input
            placeholder="مثال Pink أو #ffc0cb"
            value={colorInput}
            onChange={(e) =>
              setColorInput(e.target.value)
            }
          />


          <button
            type="button"
            onClick={() => {

              if (colorInput) {

                setProduct(prev => ({
                  ...prev,

                  colors: [
                    ...prev.colors,
                    colorInput
                  ]

                }));

                setColorInput("");

              }

            }}
          >
            Add Color
          </button>


          <p>

            {product.colors.map(
              (c, i) => (

                <span key={i}>
                  {c} ,
                </span>

              )
            )}

          </p>


          {/* SIZES */}

          <h3>
            Sizes 📏
          </h3>


          <input
            placeholder="مثال S أو M أو 3-6 Months"
            value={sizeInput}
            onChange={(e) =>
              setSizeInput(e.target.value)
            }
          />


          <button
            type="button"
            onClick={() => {

              if (sizeInput) {

                setProduct(prev => ({
                  ...prev,

                  sizes: [
                    ...prev.sizes,
                    sizeInput
                  ]

                }));

                setSizeInput("");

              }

            }}
          >
            Add Size
          </button>


          <p>

            {product.sizes.map(
              (s, i) => (

                <span key={i}>
                  {s} ,
                </span>

              )
            )}

          </p>


          {/* IMAGES */}

          <input
            type="file"
            multiple
            accept="image/*"
            onChange={(e) =>
              setFiles(
                [...e.target.files]
              )
            }
          />


          <button type="submit">
            إضافة المنتج
          </button>

        </form>


        {/* PRODUCTS */}

        <div className="products-admin">

          {products.map(item => (

            <div
              className="admin-card"
              key={item.id}
            >

              {item.images?.[0] && (

                <img
                  src={item.images[0]}
                  alt="product"
                />

              )}


              <h3>
                {item.name}
              </h3>


              <p>
                {item.description}
              </p>


              <p>
                القسم: {item.category}
              </p>


              {item.subCategory && (

                <p>
                  التصنيف: {item.subCategory}
                </p>

              )}


              {item.accessory && (

                <p>
                  النوع: {item.accessory}
                </p>

              )}


              <p>
                السعر: ${item.price}
              </p>


              <p>
                🎨 Colors:
                {item.colors?.join(" , ")}
              </p>


              <p>
                📏 Sizes:
                {item.sizes?.join(" , ")}
              </p>


              <button
                onClick={() =>
                  editPrice(item.id)
                }
              >
                تعديل السعر
              </button>


              <button
                onClick={() =>
                  deleteProduct(item.id)
                }
              >
                حذف
              </button>

            </div>

          ))}

        </div>

      </div>

    </div>

  );

}

export default Admin;